import React from 'react'

import type { NextPage } from 'next'

import { homeEquity } from 'data/seo'
import HomeEquity from 'views/home-equity'

const HomeEquityPage: NextPage = () => <HomeEquity />

export default HomeEquityPage

export async function getStaticProps() {
  return {
    props: { SEO: homeEquity }
  }
}
